import Vue from "vue";
import Router from "vue-router";

import Home from "../views/Home.vue";
import GardenProposition from "../views/GardenProposition.vue";
import About from "../views/About.vue";

Vue.use(Router);

const components = [
	{ component: Home },
	{ component: GardenProposition },
	{ component: About }
];

const router = menu => {
	const routeConfig = menu.data.map((item, i) => ({
		path: `/${item.url}`,
		props: { id: item.content_id },
		...components[i]
	}));

	const routes = [
		{
			path: "/",
			redirect: routeConfig[0].path
		},
		...routeConfig
	];

	return new Router({
		mode: "history",
		linkActiveClass: "",
		linkExactActiveClass: "navigation__link--active",
		routes
	});
};

export default router;
